import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Splash from '../views/Splash.vue'
import HomeownerBenefits from '../views/HomeownerBenefits.vue'
import Partnership from '../views/Partnership'
import PlatformOverview from '../views/PlatformOverview'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Splash',
    component: Splash
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/homeowner-benefits',
    name: 'Homeowner Benefits',
    component: HomeownerBenefits
  },
  {
    path: '/partnership',
    name: 'Partnership',
    component: Partnership
  },
  {
    path: '/platform-overview',
    name: 'Platform Overview',
    component: PlatformOverview
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView();
  }
})

export default router
